import axiosInstance from "services/AxiosInstance";
import { ResponseType, TCommodity } from "types";

export const getCommodityService = async (commodityId?: string): Promise<ResponseType<TCommodity>> => {
  const response = await axiosInstance.get(`items/${commodityId}`);
  return response.data;
};
